export default __webpack_public_path__ + "images/3I.27b6cba.png";